import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useIntl } from 'react-intl';

const FileUuid = ({ file }) => {
  const intl = useIntl();

  const [linkCopied, setLinkCopied] = useState(false);

  const copyLink = () => {
    setLinkCopied(true);
    setTimeout(() => {
      setLinkCopied(false);
    }, 2000);
  };

  return (
    <span className="file-uuid">
      {intl.formatMessage({
        defaultMessage: 'File ID: {fileId}',
      }, { fileId: `...${file.uuid.split('-')[4]}` })}
      <CopyToClipboard
        text={file.uuid}
        title={intl.formatMessage({ defaultMessage: 'Copy file ID' })}
        options={{
          format: 'text/plain',
        }}
        onCopy={copyLink}
      >
        {linkCopied ? (
          <span>{intl.formatMessage({ defaultMessage: 'Copied' })}</span>
        ) : (
          <a href="#copy" onClick={(e) => { e.preventDefault(); }}>
            <i className="far fa-copy" />
          </a>
        )}
      </CopyToClipboard>
    </span>
  );
};

FileUuid.propTypes = {
  file: PropTypes.object.isRequired,
};

export default FileUuid;
